<template>
  <div>
    <b-spinner v-if="loadingRoles"></b-spinner>
    <div>
      <v-btn
        color="success"
        name="btnSuperAdmin"
        id="btnSuperAdmin"
        :disabled="togglingSuperAdmin"
        v-on:click="toggleSuperAdmin()"
      >{{superAdminToggleText}}</v-btn>
      <v-btn
        color="success"
        name="btnFactoryWorker"
        id="btnFactoryWorker"
        :disabled="togglingFactoryWorker"
        v-on:click="toggleFactoryWorker()"
      >{{factoryWorkerToggleText}}</v-btn>
    </div>
    <br />
  </div>
</template>

<script>
var restHelper = require("../restHelper").default
var middleware = require("../middleware").default

export default {
  props: {
    userId: Number,
    factoryWorker: Boolean,
    superAdmin: Boolean
  },
  data() {
    return {
      superAdminToggleText: "",
      factoryWorkerToggleText: "",
      togglingSuperAdmin: false,
      togglingFactoryWorker: false,
      isSuperAdmin: this.superAdmin,
      isFactoryWorker: this.factoryWorker
    }
  },
  watch: {
    isSuperAdmin: {
      immediate: true,
      handler(newVal, oldVal) {
        this.superAdminToggleText = newVal ? "Disable Admin" : "Enable Admin"
      }
    },
    isFactoryWorker: {
      immediate: true,
      handler(newVal, oldVal) {
        this.factoryWorkerToggleText = newVal
          ? "Disable Factory Worker"
          : "Enable Factory Worker"
      }
    }
  },
  methods: {
    async toggleSuperAdmin() {
      this.togglingSuperAdmin = true

      try {
        await restHelper.updateUser(this.userId, {
          superAdmin: !this.isSuperAdmin
        })
        this.isSuperAdmin = !this.isSuperAdmin
      } catch (error) {}

      this.togglingSuperAdmin = false
    },

    async toggleFactoryWorker() {
      this.togglingFactoryWorker = true

      try {
        await restHelper.updateUser(this.userId, {
          factoryWorker: !this.isFactoryWorker
        })
        this.isFactoryWorker = !this.isFactoryWorker
      } catch (error) {}

      this.togglingFactoryWorker = false
    }
  }
}
</script>

